import { useContext } from "react";
import { ROType } from "../../../../types/enums";
import { RetailOrderContext } from "../context/RetailOrderContext";

export default function PhotoReferenceGuideLink() {

	const { order } = useContext(RetailOrderContext);

	return (<>
		{
			order.details.roTypeID === ROType.CabinetInstallOrder &&
			<a href="https://s3.us-east-1.amazonaws.com/sage.public-docs.inscyth/Cabinet+Installation+Photo+Guide.pdf"
				target="_blank"
				className="document-link">
				<i className="dx-icon dx-icon-download" />
				Download Photo Reference Guide
			</a>
		}
	</>
	)
} 
